import React from 'react';
import { DefaultCard } from '../components/DefaultCard';
import { SeenCard } from '../components/SeenCard';
import { ExpandedVerticalCard } from '../components/ExpandedVerticalCard';
import { PremiumChannelCard } from '../components/PremiumChannelCard';
import { MyListCard } from '../components/MyListCard';
import { OverlayCard } from '../components/OverlayCard';
import { RankingCard } from '../components/RankingCard';
import { VerticalCard } from '../components/VerticalCard';
import { ToonCard } from '../components/ToonCard';
import { PosterRecording } from '../components/PosterRecording';
import { getUserIsKids } from '../../../../../utils/User';
import PlanSelectorCard from '../components/PlanSelectorCard';
import { SubMenuCard } from '../components/SubMenuCard';
import { ChannelCard } from '../components/ ChannelCard';
import { LiveEventCard } from '../components/LiveEventCard';

export const useGetItemType = () => {
  const getComponent = ({
    carouselType,
    contentInfo,
    node,
    index,
    name,
    rankingPlace,
    carouselSubType,
    title,
    setPlanClicked,
    contentPosition,
  }) => {
    if (name === 'Lo-mejor-de-los-canales-Premiu') {
      carouselType = 'bestofpremiumchannel';
    }

    let isKid = false;
    try {
      isKid = getUserIsKids();
    } catch {
      isKid = false;
    }

    switch (carouselType) {
      case 'Carrouselhorizontal':
        return (
          <DefaultCard
            contentInfo={contentInfo}
            carouselTitle={title}
            contentPosition={contentPosition}
          />
        );
      case 'Carrouselverticalampliado':
        return (
          <ExpandedVerticalCard
            contentInfo={contentInfo}
            carouselTitle={title}
            contentPosition={contentPosition}
          />
        );
      case 'Carrouselvertical':
        return (
          <VerticalCard
            contentInfo={contentInfo}
            carouselTitle={title}
            contentPosition={contentPosition}
          />
        );
      case 'seen':
        if (carouselSubType === 'Carrouselvertical' && !isKid) {
          return (
            <VerticalCard
              contentInfo={contentInfo}
              carouselTitle={title}
              contentPosition={contentPosition}
            />
          );
        }
        return (
          <SeenCard
            contentInfo={contentInfo}
            node={node}
            index={index}
            contentType={carouselType}
            carouselTitle={title}
            contentPosition={contentPosition}
          />
        );
      case 'premiumchannel':
        return (
          <PremiumChannelCard
            contentInfo={contentInfo}
            carouselTitle={title}
            contentPosition={contentPosition}
          />
        );
      case 'favorited':
        return (
          <MyListCard
            contentInfo={contentInfo}
            node={node}
            index={index}
            contentType={carouselType}
            carouselSubType={carouselSubType}
            carouselTitle={title}
            contentPosition={contentPosition}
          />
        );
      case 'bestofpremiumchannel':
        return (
          <OverlayCard
            contentInfo={contentInfo}
            carouselTitle={title}
            contentPosition={contentPosition}
          />
        );
      case 'Carrousellomastop':
        return (
          <RankingCard
            contentInfo={contentInfo}
            rankingPlace={rankingPlace}
            carouselTitle={title}
            contentPosition={contentPosition}
          />
        );
      case 'tooncharacter':
        return (
          <ToonCard
            contentInfo={contentInfo}
            contentPosition={contentPosition}
          />
        );
      case 'admincms_userchannels':
        return (
          <VerticalCard
            contentInfo={contentInfo}
            isChannels
            carouselTitle={title}
            contentPosition={contentPosition}
          />
        );
      case 'recording':
        return (
          <PosterRecording
            contentInfo={contentInfo}
            node={node}
            index={index}
            carouselType={carouselType}
            carouselTitle={title}
            contentPosition={contentPosition}
          />
        );
      // case 'planselector':
      //   return (
      //     <>
      //       {contentInfo?.waspurchased === '1' ? null : (
      //         <PlanSelectorCard
      //           plan={contentInfo}
      //           setPlanClicked={setPlanClicked}
      //         />
      //       )}
      //     </>
      //   );
      case 'FavoritedLive':
        return (
          <MyListCard
            contentInfo={contentInfo}
            node={node}
            index={index}
            contentType={carouselType}
            carouselSubType={carouselSubType}
            carouselTitle={title}
            contentPosition={contentPosition}
          />
        );
      case 'submenu':
        return <SubMenuCard content={contentInfo} />;
      default:
        return (
          <DefaultCard
            contentInfo={contentInfo}
            carouselTitle={title}
            contentPosition={contentPosition}
          />
        );
    }
  };

  return { getComponent };
};
